import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Checkbox, Button } from '@mui/material';
import axios from "axios";
import Swal from "sweetalert2";

const SeleccionCadetesSecciones = ({ cadetes, finalizo, seccionId }) => {
  // Estado para almacenar los DNIs seleccionados
  const [seleccionados, setSeleccionados] = useState([]);
  const [puedo, setPuedo] = useState(false);
  const [selectAllState, setSelectAllState] = useState('indeterminate'); // 'checked', 'unchecked', 'indeterminate'
  const [nuevaSeccion, setNuevaSeccion] = useState('');

  // Manejar la selección de un cadete
  const manejarCambio = (dni) => {
    setSeleccionados((prevSeleccionados) => {
      const nuevosSeleccionados = prevSeleccionados.includes(dni)
        ? prevSeleccionados.filter((item) => item !== dni)
        : [...prevSeleccionados, dni];

      // Verificar si hay algún DNI seleccionado
      setPuedo(nuevosSeleccionados.length > 0);
      return nuevosSeleccionados;
    });
  };

  // Manejar el envío de la solicitud a la API
  const manejarEnvio = async () => {
    const cadetesSeleccionados = cadetes.filter(cadete => seleccionados.includes(cadete.cadeteDni));
    
    // Crear el objeto con los cadetes seleccionados y su nueva sección
    const dniArray = cadetesSeleccionados.map(cadete => cadete.cadeteDni);
    const resultado = {
        dniArray: cadetesSeleccionados.map(cadete => cadete.cadeteDni)
      };

    const token = btoa(`${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`);
    const client = axios.create({
      baseURL: `${process.env.REACT_APP_BASEURL}Ncadetes/actualizaSeccionCadetes`, // Cambia esta URL según tu API
      headers: {
        Authorization: `Basic ${token}`,
      },
    });
// console.log(seccionId)
    try {
      const response = await client.post("/" + 15, resultado);
      if (response.data) {
        Swal.fire("Se ha actualizado la sección de los cadetes seleccionados", "La operación fue exitosa", "success");
        finalizo("exito");
        setSeleccionados([]);
        setPuedo(false);
        setNuevaSeccion('');
        
      } else {
        Swal.fire("No se pudo actualizar la sección", "Hubo un error al procesar la solicitud", "error");
//         console.log(response.data);
      }
   } catch (error) {
      console.error("Error al enviar la solicitud:", error);
    }
  };

  // Manejar la selección de todos los cadetes
  const manejarSelectAll = () => {
    if (selectAllState === 'unchecked') {
      setSeleccionados(cadetes.map((fila) => fila.cadeteDni));
      setSelectAllState('checked');
      setPuedo(true);
    } else if (selectAllState === 'checked') {
      setSeleccionados([]);
      setSelectAllState('unchecked');
      setPuedo(false);
    } else {
      setSeleccionados(cadetes.map((fila) => fila.cadeteDni));
      setSelectAllState('checked');
    }
  };

  // Cambiar el estado del "select all" dependiendo de los seleccionados
  const manejarSelectChange = () => {
    if (seleccionados.length === 0) {
      setSelectAllState('unchecked');
      setPuedo(false);
    } else if (seleccionados.length === cadetes.length) {
      setSelectAllState('checked');
    } else {
      setSelectAllState('indeterminate');
    }
  };

  useEffect(() => {
    manejarSelectChange();
  }, [seleccionados]);

  return (
    <div>
      <h3>Seleccionar Cadetes y Modificar Sección</h3>

      {/* Contador de cadetes seleccionados */}
      <div style={{ marginBottom: '10px', fontSize: '16px' }}>
        {seleccionados.length} Cadete{seleccionados.length !== 1 ? 's' : ''} seleccionado{seleccionados.length !== 1 ? 's' : ''}
      </div>

      <Table sx={{ '& th, & td': { padding: '8px' }, borderCollapse: 'collapse' }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Checkbox
                checked={selectAllState === 'checked'}
                indeterminate={selectAllState === 'indeterminate'}
                onChange={manejarSelectAll}
                inputProps={{ 'aria-label': 'select all cadetes' }}
              />
            </TableCell>
            <TableCell>Cadete</TableCell>
            <TableCell>DNI</TableCell>
            <TableCell>Compania Actual</TableCell>
            <TableCell>Sección Actual</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cadetes.map((fila) => (
            <TableRow key={fila.cadeteDni}>
              <TableCell>
                <Checkbox
                  checked={seleccionados.includes(fila.cadeteDni)}
                  onChange={() => manejarCambio(fila.cadeteDni)}
                  inputProps={{ 'aria-label': `select cadete ${fila.cadeteDni}` }}
                />
              </TableCell>
              <TableCell>{fila.cadeteApellido} {fila.cadeteNombre}</TableCell>
              <TableCell>{fila.cadeteDni}</TableCell>
              <TableCell>{fila.Seccion.Compania.nombre}</TableCell>
              <TableCell>{fila.Seccion.nombre}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Botón para enviar los cambios */}
      {puedo ? (
        <Button onClick={manejarEnvio} variant="contained" color="primary">
          Modificar Sección
        </Button>
      ) : (
        <Button variant="contained" disabled color="primary">
          Modificar Sección
        </Button>
      )}
    </div>
  );
};

export default SeleccionCadetesSecciones;
